module.exports = __webpack_public_path__ + "media/images/file-icons/128/006-record-48885905b59ba89a445311c4e86b1630.png";